import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '../router';

let analyticsTrackingId = 'UA-126074241-4';

if (location.hostname === 'beehive.ae.be') {
    analyticsTrackingId = 'UA-126074241-1';
} else if (location.hostname.indexOf('-dev') > -1) {
    analyticsTrackingId = 'UA-126074241-3';
} else if (location.hostname.indexOf('-test') > -1) {
    analyticsTrackingId = 'UA-126074241-2';
}

Vue.use(VueAnalytics, { id: analyticsTrackingId, router });
